import { createApp } from 'vue'
import TemperatureConvertor from './TemperatureConvertor.vue'
import './assets/global.css'

createApp(TemperatureConvertor).mount('#temperature')
